import { GridValueFormatterParams } from '@mui/x-data-grid'
import { dayjsCustom } from '../utils'
import { createFilterStore } from './filter-store'
import { createViewMode } from './create.view-mode'
import { createViewModeButtons } from './view-mode.units'
import { getViewModeFromURL, syncViewModeToURL } from './query-param-url'
import { createConvertFilterToGraphQL } from './convert-filter-to-graphql'
import { createKeyConverter } from '../http-service/graphql/key-converter'
import { convertFilterToQueryParam, getQueryFromURL, getSeedKeyFromURL, syncQueryToURL } from './query-param-url'
import createPaginationBar from './create.pagination-bar'
import createDataView from './create.data-view'

const formatDateString = 'MM/DD/YYYY HH:mm'

export interface IFormatterDateOptions {
  formatString?: string
  showRelative?: boolean
}

class DinoDataViewBase {
  createDataView = createDataView

  createKeyConverter = createKeyConverter

  createConvertFilterToGraphQL = createConvertFilterToGraphQL

  createFilterStore = createFilterStore

  createPaginationBar = createPaginationBar

  createViewMode = createViewMode

  createViewModeButtons = createViewModeButtons

  syncQueryToURL = syncQueryToURL

  getQueryFromURL = getQueryFromURL

  getSeedKeyFromURL = getSeedKeyFromURL

  syncViewModeToURL = syncViewModeToURL

  getViewModeFromURL = getViewModeFromURL

  convertFilterToQueryParam = convertFilterToQueryParam

  //#region Value Formatter
  formatterDate = (value: any, options?: IFormatterDateOptions): string => {
    const f = options?.formatString ?? formatDateString
    const showRelative = options?.showRelative ?? false
    try {
      if (!value) return ''

      const date = dayjsCustom(value)
      const formatted = date.format(f)

      return showRelative ? `${formatted} (${dayjsCustom().to(date)})` : formatted
    } catch (error) {
      return ''
    }
  }

  valueFormatterDate = (options?: IFormatterDateOptions) => {
    return (params: GridValueFormatterParams<any>) => this.formatterDate(params.value, options)
  }
  //#endregion
}
export const DinoDataView = new DinoDataViewBase()
export default DinoDataView
